import { Injectable } from '@angular/core';
import { DefaultDashboardSelection } from '@models/businesses';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './dashboard.actions';

@Injectable({
	providedIn: 'root',
})
export class DashboardDataDispatch {
	@Dispatch()
	Filter = (filter: DefaultDashboardSelection): actions.Filter =>
		new actions.Filter(filter);

	@Dispatch()
	SetDate = (date: number | string): actions.SetDate =>
		new actions.SetDate(date);
}
